<div class="verify">
  <div class="verify__card card">
    <!-- Brand -->
    <div class="verify__brand">
      <img
        class="verify__brand-logo"
        src="assets/images/logo-login.png"
        alt="LOMY"
      />
      <app-lomy-logo size="p"></app-lomy-logo>
    </div>

    <h1 class="verify__title">{{ "verifyEmail.title" | transloco }}</h1>
    <p class="verify__lead">
      {{ "verifyEmail.subtext" | transloco : { email: email } }}
    </p>

    <form class="verify__form" (ngSubmit)="verify()">
      <div class="field">
        <label class="field__label" for="verify-code">{{
          "verifyEmail.codeLabel" | transloco
        }}</label>
        <div class="field__input">
          <mat-icon fontSet="material-icons-round">password</mat-icon>
          <input
            id="verify-code"
            class="verify__code-input"
            type="text"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="6"
            name="code"
            [(ngModel)]="code"
            (ngModelChange)="onCodeChanged()"
            [placeholder]="'verifyEmail.codePlaceholder' | transloco"
          />
        </div>
      </div>

      <app-button
        class="verify__cta"
        [fullWidth]="true"
        [text]="'verifyEmail.confirmCta' | transloco"
        [disabled]="verifying() || code.trim().length !== 6"
      ></app-button>
    </form>

    <div class="verify__resend">
      <span>{{ "verifyEmail.resendPrompt" | transloco }}</span>
      <a
        class="accent-link"
        [class.is-disabled]="resending()"
        (click)="resend()"
        >{{ "verifyEmail.resendCta" | transloco }}</a
      >
    </div>

    <div class="verify__resend" *ngIf="!changingEmail()">
      <span>{{ "verifyEmail.changePrompt" | transloco }}</span>
      <a class="accent-link" (click)="toggleChangeEmail(true)">{{
        "verifyEmail.changeCta" | transloco
      }}</a>
    </div>

    <!-- Wrong e-mail: correct the address (password proves account ownership). -->
    <form
      class="verify__form verify__change"
      *ngIf="changingEmail()"
      (ngSubmit)="changeEmail()"
    >
      <h2 class="verify__change-title">
        {{ "verifyEmail.changeTitle" | transloco }}
      </h2>
      <p class="verify__lead">{{ "verifyEmail.changeSubtext" | transloco }}</p>

      <div class="field">
        <label class="field__label" for="verify-new-email">{{
          "verifyEmail.newEmailLabel" | transloco
        }}</label>
        <div class="field__input">
          <mat-icon fontSet="material-icons-round">mail</mat-icon>
          <input
            id="verify-new-email"
            type="email"
            name="newEmail"
            autocomplete="email"
            [(ngModel)]="newEmail"
            [placeholder]="'verifyEmail.newEmailPlaceholder' | transloco"
          />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="verify-password">{{
          "verifyEmail.passwordLabel" | transloco
        }}</label>
        <div class="field__input">
          <mat-icon fontSet="material-icons-round">lock</mat-icon>
          <input
            id="verify-password"
            type="password"
            name="password"
            autocomplete="current-password"
            [(ngModel)]="password"
            [placeholder]="'verifyEmail.passwordPlaceholder' | transloco"
          />
        </div>
      </div>

      <app-button
        class="verify__cta"
        [fullWidth]="true"
        [text]="'verifyEmail.changeConfirmCta' | transloco"
        [disabled]="changeSubmitting() || !newEmail.trim() || !password"
      ></app-button>
      <div class="verify__resend">
        <a class="accent-link" (click)="toggleChangeEmail(false)">{{
          "verifyEmail.changeCancelCta" | transloco
        }}</a>
      </div>
    </form>
  </div>
</div>
